import { rollForwardDate } from "../objects/roll_forward_date_function";
import { calcInterestAmt } from "../../../objects/CommonUse/calc_interest_amt";
import determineInterestRates from "../objects/determine_interest_rates";
import SavingsPolicyOptions from "../../moneyBuilder/savings/datasets/savings_policy_options";
import addToSavingsTranArr from "../../moneyBuilder/savings/objects/add_to_savings_tran_arr";
import roundAndReturnString from "../../../objects/CommonUse/round_and_return_string";
import applyInterestToCDList from "./applyInterestToCDList";

export const processSavingsTypeEndOfTurn = (savingsObj, gameDate, currentPrice, companyMatchRate, tranArr,
        tranNbr) => {
    
    let cashChg = 0;
    let savingsType = savingsObj.savingsType;
    let intEndDate = "";
   
    if (savingsObj.savingsClass === "bank"){
        const intRateStartDate = savingsObj.intRateStartDate;
        if (intRateStartDate && intRateStartDate !== ""){
            intEndDate = rollForwardDate(intRateStartDate, 12);
        }
        // interest rate is changed once each year
        if (gameDate > intEndDate || 
            (savingsObj.intRateStartDate && savingsObj.intRateStartDate === "")){
                let newIntRate = determineInterestRates(savingsType);
                const interestRate = (newIntRate * 100).toFixed(2);
                savingsObj.interestRate = roundAndReturnString(interestRate, 2);
                savingsObj.intRateStartDate = gameDate;
        }
    }
       
    const savingTotals = savingsObj.savingTotals;
    let totalSavings = savingTotals.totalSavings;
   
    if (savingsObj.monthlyDepositAmt){
        const tranAmt = +savingsObj.monthlyDepositAmt;
        tranNbr = addToSavingsTranArr("Deposit", tranAmt, gameDate, tranNbr, currentPrice, tranArr);
        if (savingsObj.savingsClass === "retirement"){
            if (companyMatchRate){
                const companyMatchAmt = savingsObj.monthlyDepositAmt * companyMatchRate;
                tranNbr = addToSavingsTranArr("Company Match", companyMatchAmt, gameDate, tranNbr, currentPrice, 
                    tranArr);
            }
        }
        cashChg -= (+savingsObj.monthlyDepositAmt);
    }
    let intAmt = 0;
    if (savingsObj.savingsClass === "bank"){
        const intRate = +savingsObj.interestRate / 100;
        if (savingsType === "CD"){
            intAmt = applyInterestToCDList(intRate, savingsObj.CDList);
        }else{
            intAmt = calcInterestAmt(+totalSavings, intRate, "month");
        }
        tranNbr = addToSavingsTranArr("Interest Earned", intAmt, gameDate, tranNbr, "", tranArr);
    }
        
    // exclude investments (such as 401(k)) where the interest is not taxable when it is earned.
    const savingsGeneralInfo = SavingsPolicyOptions.find(elem => elem.type === savingsType);
    if (savingsGeneralInfo && savingsGeneralInfo.taxExempt === false){
        const currentYear = gameDate.split("-")[0];
        const yearIndx = savingsObj.yearArr.findIndex(elem => elem.year === currentYear);
        if (yearIndx === -1){
            const yearArrObj = {year: currentYear, totalInterest: intAmt, penaltyAmt: 0, transferAmt: 0};
            savingsObj.yearArr.push(yearArrObj);
        }else{
            let newYearInterest = +savingsObj.yearArr[yearIndx].totalInterest + +intAmt;
            savingsObj.yearArr[yearIndx].totalInterest = roundAndReturnString(newYearInterest,4); 
        }
    }
    if (savingsType === "CD"){
        const gameMonth = gameDate.split('-')[1];
        const CDIndex = savingsObj.CDList.findIndex(elem => elem.startDate.split('-')[1] === gameMonth);
        if (CDIndex !== -1){
            const CDObj = savingsObj.CDList[CDIndex];
            if (CDObj.autoRollover === true){
                //  no update to savingsInfo
            }else{
                if (CDObj.startDate !== gameDate){
                    let  CDBalance = +CDObj.amount - +CDObj.transferAmt;
                    cashChg += +CDBalance.toFixed(2) + +CDObj.intAmt;
                    CDBalance = +(+CDBalance * -1).toFixed(2);
                    tranNbr = addToSavingsTranArr("CD Closed", CDBalance, gameDate, tranNbr, "", tranArr);
                    let intAmt = (+CDObj.intAmt * -1).toFixed(2);
                    tranNbr = addToSavingsTranArr("CD Interest Paid", intAmt, gameDate, tranNbr, "", tranArr);
                    // not including transfer amts/fees because player has already paid them
                    savingsObj.CDList.splice(CDIndex, 1);  //  CD has been fully closed
                }
            }
        }
    }
    let savingsInfoObj = {savingsObj: savingsObj, cashChg: cashChg, tranNbr: tranNbr};
    return savingsInfoObj;
}
export default processSavingsTypeEndOfTurn;